import { render, staticRenderFns } from "./logisPhotoLibraryV0.vue?vue&type=template&id=7126aa78&scoped=true"
import script from "./logisPhotoLibraryV0.vue?vue&type=script&lang=js"
export * from "./logisPhotoLibraryV0.vue?vue&type=script&lang=js"
import style0 from "./logisPhotoLibraryV0.vue?vue&type=style&index=0&id=7126aa78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126aa78",
  null
  
)

export default component.exports